import { lazy } from 'react'

export const AddNewClientModalAsync = lazy(() =>
    import('./AddNewClientModal').then((component) => ({
        default: component.AddNewClientModal,
    }))
)
